import React from 'react';
import { Page } from 'components';
import { CarriersProvider } from './CarriersContext';
import Carriers from './Carriers';


let Index = () => {
    return (
        <CarriersProvider>
            <Page title="Carriers">
                <Carriers />
            </Page>
        </CarriersProvider>
    );
}

export default Index;